// docs: https://github.com/altostra/type-validations#readme
import { objectOf, maybe } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isEmailIpWarmingAppGroupIdEngagementDataChunkResult = objectOf({
  upload_id: string,
  identifier_type: maybe(string),
});
